/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { getStoreConfig } from '@/account/api';
import { StoreConfigModel } from '@/account/data/models';
import { useEffect, useState } from 'preact/hooks';

export const useGetStoreConfigs = () => {
  const [passwordConfigs, setPasswordConfigs] = useState<{
    minLength: number;
    requiredCharacterClasses: number;
  } | null>(null);

  useEffect(() => {
    const storeConfigString = sessionStorage.getItem('accountStoreConfig');

    const cachedStoreConfig: StoreConfigModel = storeConfigString
      ? JSON.parse(storeConfigString)
      : null;

    if (cachedStoreConfig) {
      const { minLength, requiredCharacterClasses } = cachedStoreConfig;

      setPasswordConfigs({
        minLength,
        requiredCharacterClasses,
      });
    } else {
      getStoreConfig().then((response) => {
        if (response) {
          const { minLength, requiredCharacterClasses } = response;

          sessionStorage.setItem(
            'accountStoreConfig',
            JSON.stringify(response)
          );

          setPasswordConfigs({
            minLength,
            requiredCharacterClasses,
          });
        }
      });
    }
  }, []);

  return { passwordConfigs };
};
